import { observable, action } from 'mobx';
import IUserService from '../../services/spi/IUserService';
import FirebaseUserService from '../../services/impl/firebase/FirebaseUserService';
import IUser, { IUserStatusType } from '../../types/IUser';
import IRole from '../../types/IRole';
import { toast } from "react-toastify"


const BlankUser = {
  uid: '',
  userName: '',
  image: '',
  title: "",
  firstName: "",
  lastName: "",
  status: IUserStatusType.Active,
  lastLogin: new Date(),
  roles: [{
    name: 'SALES_USER'
  }],
  phone: "",
  email: "",
  password: "",
  createdOn: new Date()
};

class UserStore{
  rootStore: any;
  @observable users:Array<IUser> = [];
  @observable userRoles: Array<IRole> = [];
  @observable user:IUser = {
    uid: '',
    userName: '',
    title: "",
    firstName: "",
    image: '',
    lastName: "",
    status: IUserStatusType.Active,
    lastLogin: new Date(),
    roles: [{
      name: 'SALES_USER'
    }],
    phone: "",
    email: "",
    password: "",
    createdOn: new Date()
  };
  userService = {} as IUserService;

  constructor(rootStore:any) {
    this.rootStore = rootStore;
    this.userService = new FirebaseUserService();
  }

  @action getUsers = async () => {
    try{
      this.users = await this.userService.getUsers('', 0,5);
    }catch(e){
      console.log(e)
      toast.error('Could not fetch users');
    }
  }

  @action getRoles = async () => {
    try {
      this.userRoles = await this.userService.getRoles();
    } catch (e) {
      console.log(e)
      toast.error('Could not fetch Roles');
    }
  }

  @action setAttribute = (attrName:string, attrValue:string) => {
    let attrObj:any = {};
    attrObj[attrName] = attrValue;
    Object.assign(this.user, attrObj);
  }

  @action setRolesAttribute = (attrName: string, attrValue: Array<any>) => {
    let roles = attrValue && attrValue.length ? attrValue.map((item)=>{return({name: item.label})}) : [];
    console.log(roles);
    // this.user.roles = roles;
  }

  @action setBooleanAttributes = (attrName: string, attrValue:boolean) => {
      //this.user.status = attrValue;
  }

  @action setBlankUser = () => {
    this.user = BlankUser;
  }

  @action setUser = (user:IUser) => {
    this.user = user;
  }

  @action setAvatar = (url: string) => {
    this.user.image = url;
  }

  @action saveUser = async () => {
    const { uid } = this.user;
    console.log(this.user)
    try{
      if (uid && uid.length > 0) {
        await this.userService.updateUser(this.user);
        toast.success("User Updated Successfully");
      } else {
        await this.userService.createUser(this.user);
        toast.success("User Saved Successfully");
      }
      this.getUsers();//reload
    }catch(e){
      console.log(e);
      toast.error("Error saving User.");
    }
  }

  @action deleteUser = async (uid: string) => {
    // Delete Call Here
    toast.success("User Deleted Successfully!");
  }

}

export default UserStore;
